import { render, staticRenderFns } from "./SearchCorrespondence.vue?vue&type=template&id=6645f7f5&"
import script from "./SearchCorrespondence.vue?vue&type=script&lang=js&"
export * from "./SearchCorrespondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports